var map = {
	"./IconCV.vue": "1e29",
	"./IconChevronL.vue": "b247",
	"./IconChevronR.vue": "6ba0",
	"./IconCog.vue": "54a1",
	"./IconDesing.vue": "ba63",
	"./IconDoc.vue": "8805",
	"./IconEmail.vue": "d31b",
	"./IconFolder.vue": "d056",
	"./IconGithub.vue": "58d0",
	"./IconGitlab.vue": "2851",
	"./IconImage.vue": "a1dd",
	"./IconLinkedin.vue": "db11",
	"./IconPhone.vue": "c7e4",
	"./IconScrum.vue": "5c91",
	"./IconTelegram.vue": "d7b8",
	"./IconUsers.vue": "fc6aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ad6";